import React from 'react';

const SwitchOff = () => {
  return (
    <svg
      width="46"
      height="24"
      viewBox="0 0 46 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="46" height="24" rx="12" fill="#202020" />
      <circle cx="12" cy="12" r="11" fill="#EDEDED" />
    </svg>
  );
};

export default SwitchOff;
